/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_When_TitleInputs */

const en_cmp_when_title = /** @type {(inputs: Cmp_When_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`When to choose ${i?.name} instead`)
};

const id_cmp_when_title = /** @type {(inputs: Cmp_When_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kapan sebaiknya memilih ${i?.name}`)
};

/**
* | output |
* | --- |
* | "When to choose {name} instead" |
*
* @param {Cmp_When_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_when_title = /** @type {((inputs: Cmp_When_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_When_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_when_title(inputs)
	return en_cmp_when_title(inputs)
});